export const TRELLO_COLORS = {
  default: 'B6BBBF',
  yellow: 'F2D600',
  purple: 'C377E0',
  blue: '0079BF',
  red: 'EB5A46',
  green: '61BD4F',
  orange: 'ff9f1a',
  black: '4d4d4d',
  sky: '00C2E0',
  pink: 'FF78CB',
  lime: '51E898',
}
